import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const s = localStorage.getItem("algo_user");
    return s ? JSON.parse(s) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("algo_token", data.token);
    localStorage.setItem("algo_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("algo_token", data.token);
    localStorage.setItem("algo_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("algo_token");
    localStorage.removeItem("algo_user");
    setUser(null);
  };

  useEffect(() => {
    const token = localStorage.getItem("algo_token");
    if (token && !user) {
      setLoading(true);
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("algo_user", JSON.stringify(r.data));
      }).catch(() => logout()).finally(() => setLoading(false));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

